import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../context/firebase';
import { useHistory, withRouter } from 'react-router-dom';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as CLIENT_ID from '../../constants/helloSignClientId';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import CloseIcon from '@material-ui/icons/Close';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import dayjs, { extend } from 'dayjs';
import HelloSign from 'hellosign-embedded';
import { useLocation } from 'react-router';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SettingsIcon from '@material-ui/icons/Settings';
import StopIcon from '@material-ui/icons/Stop';
import _, { isEmpty, stubTrue } from 'lodash';
import clsx from 'clsx';
import isEqual from 'lodash/isEqual';
import './Clients.css';
import {
	CompassCalibrationOutlined,
	SettingsBackupRestoreTwoTone,
} from '@material-ui/icons';
import {
	makeStyles,
	Paper,
	Table,
	TableCell,
	TableHead,
	TableRow,
	Tooltip,
	Tab,
	Tabs,
	withStyles,
	Button,
	CircularProgress,
	TablePagination,
	Dialog,
	DialogActions,
	DialogTitle,
} from '@material-ui/core';
import Modal from '../layout/modal/Modal';
import {
	GetDocumentRef,
	SaveClientSignatureRequestInfo,
} from '../document/SaveAndLoadDocument';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack'; // USE THIS FOR DEV
//import { Document, Page } from 'react-pdf'; //TURN THIS ON FOR PRODUCTION
import { SetClientToNotVisible } from '../../api/Clients/setClientToNotVisible.api';
import { AddNewClient } from '../../api/Clients/addNewClient.api';
import { GetClientDocumentData } from '../../api/Clients/getClientDocumentData.api';
import { GetClientAPSFiles } from '../../api/Clients/getClientDocumentData.api';
import { GetClientCondoFiles } from '../../api/Clients/getClientDocumentData.api';
import { GetClientExtraFilesBySubject } from '../../api/Clients/getClientDocumentData.api';
import { GetDocumentByInfoCondoDoc } from '../../api/Clients/getClientDocumentForm.api';
import { CancelAPSForm } from './editDocumentsToClient';
import { CancelCondoForm } from './editDocumentsToClient';
import { CancelExtraForm } from './editDocumentsToClient';
import { CreateDocumentForm } from '../createDocumentForms/CreateDocumentForm';
import { ClearThisClientDocumentInfo } from '../../api/Clients/clearClientDocumentInfo.api';
import * as firebaseDocumentCalls from '../../api/Clients/getFirebaseDocumentInfo.api';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';
import * as ORIGINAL_HREF from '../../constants/originalHref';
import SearchBox from '../searchBox/SearchBox';
import ClientList from './ClientList';
import CoBroker from './CoBrokerForm';
import LawyerForm from './LawyerForm';
import MortgageForm from './MortgageForm';
import ExtendCoolingPeriod from './ExtendCoolingPeriod/ExtendCoolingPeriod';

//redux
import { getVisibleClients, handleDoc } from '../../redux/clients/actions';
import { connect } from 'react-redux';
import getAllLeadsEmails from '../../api/SendEmails/getAllLeadsEmails.api';
import ViewLeads from './ViewLeads';
import AddNewClientJsx from './AddNewClientJsx';
import { validateEmail } from '../../utils/validateEmail';
import Alert from '@material-ui/lab/Alert';
import CustomAlerts from '../alerts/CustomAlerts';

const Clients = ({
	lotId,
	getVisibleClients,
	visibleClients,
	coBrokersSalesAgent,
	loading,
	handleDoc,
}) => {
	const { firebase } = useContext(FirebaseContext);
	const history = useHistory();
	const [clientDetailList, setClientDetailList] = useState([]);
	const [tabValue, setTabValue] = useState(0);
	const [alert, setAlert] = useState('');
	const [alertModal, setAlertModal] = useState('');
	const [show, setShow] = useState(false);
	const [showAddDoc, setShowAddDoc] = useState({ visible: false });
	const [showExpand, setShowExpand] = useState(false);
	const [showExtraDocForm, setShowExtraDoc] = useState(false);
	const [extraDocFormPopulation, setExtraDocPopulation] = useState({});
	const [lotID, setLotID] = useState();
	const allDocumentNames = ['APS', 'Condo Docs'];
	const [loadingX, setLoading] = useState(true);
	const [docLoading, setDocLoading] = useState(false);
	const helloClient = new HelloSign();
	const location = useLocation();
	const [searchField, setSearchField] = useState('');
	const [filteredClients, setFilteredClients] = useState();
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(50);
	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('calories');
	const [showAuditTrail, setShowAuditTrail] = useState(false);
	const [showDocInfo, setShowDocInfo] = useState(false);
	const [docInformation, setDocInformation] = useState();
	const [auditTrail, setAuditTrail] = useState();
	const [signatureDetails, setSignatureDetails] = useState();
	const [showPdfDocument, turnOnPdfDocument] = useState(false);
	const [pdfFile, setPdfFile] = useState();
	const [numPages, setNumPages] = useState(null);
	const [pageNumber, setPageNumber] = useState(1);
	const [clientJson, setClientJson] = useState();
	const [showDocModal, setShowDocModal] = useState({
		aps: false,
		condodocs: false,
		extraDocs: false,
	});
	const [customFields, setCustomFields] = useState({});
	const [customSigners, setCustomSigners] = useState({});
	const [otherCustomFields, setOtherCustomFields] = useState();
	const [select, setSelect] = useState();
	const [addItemDocModal, setAddItemDocModal] = useState({
		lawyer: false,
		coBroker: false,
		mortgage: false,
	});
	const [userType, setUserType] = useState('');
	const [viewLeads, setViewLeads] = useState(false);
	const [formData, setFormData] = useState({
		clientEmail: '',
		clientName: '',
		clientPhoneNumber: '',
	});
	const [deleteClientDialog, setDeleteClientDialog] = useState(false);
	const [dialogClientEmail, setDialogClientEmail] = useState();
	const [dialogClientJson, setDialogClientJson] = useState();
	const [dialogClientName, setDialogClientName] = useState();
	const [snackbar, setSnackbar] = useState(false);
	const [snackbarType, setSnackbarType] = useState('warning');
	const [extendModal, setExtendModal] = useState(false);
	const [extendInfo, setExtendInfo] = useState();

	const { clientEmail, clientName, clientPhoneNumber } = formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const onDocumentLoadSuccess = ({ numPages }) => {
		console.log('Document loaded success');
		setNumPages(numPages);
	};
	const [sortClientList, setSortClientList] = useState();

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	function descendingComparator(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getComparator(order, orderBy) {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}

	function stableSort(array, comparator) {
		const stabilizedThis = array?.map((el, index) => [el, index]);
		stabilizedThis?.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis?.map((el) => el[0]);
	}

	var helloSignAuthToken;

	// GetClientAuthToken(firebase).then((returned) => {
	// 	helloSignAuthToken = returned;
	// 	// console.log('Hello signs current auth token ' + helloSignAuthToken);
	// });

	if (ALL_DOCUMENTS.allDocumentTypeInfo.hasGottenInfo === false) {
		firebaseDocumentCalls.GetFirebaseDocumentInformation();
	}

	useEffect(() => {
		firebase.auth().onAuthStateChanged(async (user) => {
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;
				var currentUserType;

				console.log('Current user Id; ' + currentUserId);
				await firebase
					.database()
					.ref('/users/' + currentUserId + '/userType')
					.once('value', function (snapshot) {
						currentUserType = snapshot.val();
						console.log('THIS IS USER TYPE: ' + currentUserType);
					});
				setUserType(currentUserType);
			}
		});

		console.log('This is the loading state', loading);
	}, []);

	//set client detail list
	useEffect(async () => {
		setLoading(true);

		await getVisibleClients().then(() => {
			setClientDetailList(visibleClients);
		});
	}, []);

	useEffect(() => {
		setClientDetailList(visibleClients);
	}, [visibleClients]);

	//sort
	useEffect(() => {
		const arrayWithDoc = clientDetailList?.filter(
			(e) => e.documentInformation?.documentStatus === 'sent'
		);

		const arrayWithoutDoc = clientDetailList?.filter(
			(e) =>
				e.documentInformation?.documentStatus === 'ready' ||
				e.documentInformation?.documentStatus === undefined
		);

		const sorted = [...arrayWithDoc, ...arrayWithoutDoc];

		setSortClientList(sorted);
	}, [clientDetailList, visibleClients]);

	//search functionality
	useEffect(() => {
		const filtered = sortClientList?.filter(
			(client) =>
				client.fullName
					?.toLowerCase()
					.includes(searchField.toLowerCase()) ||
				client.clientEmail
					.toLowerCase()
					.includes(searchField.toLowerCase()) ||
				client?.documentInformation?.document?.lotActive?.lotSelected
					.toLowerCase()
					.includes(searchField.toLowerCase()) ||
				('@' + client?.salesAgentName)
					.toLowerCase()
					.includes(searchField.toLowerCase())
		);
		setFilteredClients(filtered);
	}, [searchField, sortClientList]);

	const handleDocument = useCallback(async (e) => {
		try {
			var currentUserId = firebase.auth().currentUser.uid;
			var currentUserEmail = firebase.auth().currentUser.email;
			var currentUserType;
			var currentUserPhoneNumber;
			var currentUserName;
			var clientName = e.currentTarget.dataset.name;
			var appCode = e.currentTarget.dataset.appcode;
			var expand = e.currentTarget.dataset.expand;
			var salesAgentId = e.currentTarget.dataset.salesagentid;
			var clientCreatorId = e.currentTarget.dataset.clientcreatorid;
			var clientEmailData = e.currentTarget.dataset.clientemail;
			var isEdit = e.currentTarget.dataset?.edit;
			var lot = e.currentTarget.dataset?.lot;

			console.log('isEdit in clients', lot);

			await firebase
				.database()
				.ref('/users/' + currentUserId)
				.once('value', (snapshot) => {
					currentUserType = snapshot.val().userType;
					currentUserPhoneNumber = snapshot.val().phoneNumber;
					currentUserName = snapshot.val().fullName;

					console.log(
						'Type: ' +
							currentUserType +
							', username: ' +
							currentUserName +
							', phone: ' +
							currentUserPhoneNumber
					);

					var detailsUser = {
						thisEmail: currentUserEmail,
						thisName: currentUserName,
						thisUserType: currentUserType,
						thisPhone: currentUserPhoneNumber,
						thisUID: currentUserId,
					};

					console.log('Details user: ' + JSON.stringify(detailsUser));
					history.push({
						pathname: '/doc',
						state: {
							clientCreatorId: clientCreatorId,
							clientEmail: clientEmailData,
							clientFName: clientName,
							userDetail: detailsUser,
							sellerFullName: currentUserName,
							sellerPhone: currentUserPhoneNumber,
							clientAppCode: appCode,
							salesAgentId: salesAgentId,
							lotId: lotId,
							expand: expand,
							from: 'client',
							edit: isEdit ? isEdit : null,
							lot: lot,
						},
					});
				});
		} catch (error) {
			console.log(error);
		}
	});

	const handleAddItemDoc = (e) => {
		var subject = e.currentTarget.dataset.subject;
		if (subject === 'lawyer') {
			console.log('handleAddItemDoc subject', subject);
			setAddItemDocModal({
				lawyer: true,
			});
		} else if (subject === 'cobroker') {
			setAddItemDocModal({
				coBroker: true,
			});
		} else if (subject === 'mortgage') {
			setAddItemDocModal({
				mortgage: true,
			});
		}
		setShowDocInfo(false);
	};

	const handleSaveDocInfo = () => {};

	const handleDelete = (e, clientJson) => {
		var allKeysToDelete = [];
		var deleteKey = e.currentTarget.dataset.appcode;
		var clientName = e.currentTarget.dataset.name;
		var clientEmail = e.currentTarget.dataset.clientemail;
		console.log('handleDelete clientEmail: ', clientEmail);
		console.log('handleDelete clientJson: ', clientJson);

		setDialogClientName(clientName);
		setDialogClientEmail(clientEmail);
		setDialogClientJson(clientJson);
		handleOpenDialog();
	};

	const handleClickClientDelete = () => {
		SetClientToNotVisible(dialogClientEmail, dialogClientJson).then(() => {
			setAlert(`Client of name ${dialogClientName} has been deleted.`);
			setSnackbar(true);
			setSnackbarType('success');
			setTimeout(() => {
				setAlert();
			}, 4000);
		});
		handleCloesDialog();
	};

	const handleCloesDialog = () => {
		setDeleteClientDialog(false);
	};

	const handleOpenDialog = (e, client) => {
		setDeleteClientDialog(true);
	};

	const closeModalHandler = () => setShow(false);
	const closeDocModalHandler = () => setShowAddDoc(false);
	const closeDocInfoModalHandler = () => setShowDocInfo(false);
	const closeAudittrailModalHandler = () => setShowAuditTrail(false);
	const closeExtendModalHandler = () => setExtendModal(false);
	const handleClosePdfModal = () => turnOnPdfDocument(false);
	const handleCloseEditItemModal = () => setAddItemDocModal(false);
	const handleCloseLeads = () => setViewLeads(false);
	const closeDocControlHandle = () => {
		setShowDocModal({
			aps: false,
			condodocs: false,
		});
	};
	const closeExtraDocForm = () => {
		setShowExtraDoc(false);
	};

	const manageDocModal = (
		client,
		aps,
		condodocs,
		extraDocs,
		extraDoc,
		subject
	) => {
		console.log('manageDocModal client 473', client);
		return (
			<div className='manage-doc-modal-wrapper'>
				{userType === 'salesadmin' &&
					client?.isForCurrentSalesAgent === true && (
						<Button
							variant='contained'
							color='primary'
							className={styles.extraDocBtn}
							onClick={(e) => {
								if (aps === true) {
									handleDocument(e);
								} else if (
									condodocs === true &&
									checkIfApsSent(client) &&
									checkIfSendCondoDoc(
										client['expandedClientInfo'],
										client
									) &&
									!checkIfSentDocAlready(
										client['expandedClientInfo'],
										client
									)
								) {
									var currentUserEmail =
										firebase.auth().currentUser.email;
									GetDocumentByInfoCondoDoc(
										firebase,
										client['expandedClientInfo'],
										client,
										ALL_DOCUMENTS.allDocumentTypeInfo
											.condoDocFirebaseInfo,
										ORIGINAL_HREF.originalHREF[
											'access_token'
										],
										currentUserEmail,
										client.documentInformation.document
											.individualSecondPurchaserDetails
									);
								} else if (
									condodocs == true &&
									checkIfSentDocAlready(
										client['expandedClientInfo'],
										client
									)
								) {
									setAlert(
										'APS not sent yet. Please send over an APS and try again.'
									);
									setSnackbar(true);
									setSnackbarType('warning');
									setTimeout(() => {
										setAlert('');
									}, 3000);
									closeDocControlHandle();
								} else if (condodocs === true) {
									setAlert(
										'APS must be sent and fully signed before sending ' +
											client.clientEmail +
											' the condo doc forms'
									);
									setSnackbar(true);
									setSnackbarType('warning');
									setTimeout(() => {
										setAlert();
									}, 4000);
									closeDocControlHandle();
								} else if (extraDocs === true) {
									console.log('Create doc in extra doc');
									setCustomFields({});
									setShowExtraDoc(true);
									setShowDocModal(false);
								}
							}}
							data-appcode={client?.appCode}
							data-name={client?.fullName}
							data-clientemail={client?.clientEmail}
							data-cobrokerid={client?.coBrokerId}
							data-clientcreatorid={client?.clientCreatorId}
							data-lot={
								client.documentInformation?.document?.lotActive
									?.lotSelected
							}
						>
							{aps === true &&
							client.documentInformation?.document
								? 'Continue Document'
								: 'Create Document'}
						</Button>
					)}
				{userType === 'superadmin' && (
					<Button
						variant='contained'
						color='primary'
						className={styles.extraDocBtn}
						onClick={(e) => {
							if (aps === true) {
								handleDocument(e);
							} else if (
								condodocs === true &&
								checkIfApsSent(client) &&
								checkIfSendCondoDoc(
									client['expandedClientInfo'],
									client
								) &&
								!checkIfSentDocAlready(
									client['expandedClientInfo'],
									client
								)
							) {
								var currentUserEmail =
									firebase.auth().currentUser.email;
								GetDocumentByInfoCondoDoc(
									firebase,
									client['expandedClientInfo'],
									client,
									ALL_DOCUMENTS.allDocumentTypeInfo
										.condoDocFirebaseInfo,
									ORIGINAL_HREF.originalHREF['access_token'],
									currentUserEmail,
									client.documentInformation.document
										.individualSecondPurchaserDetails
								);
							} else if (
								condodocs == true &&
								checkIfSentDocAlready(
									client['expandedClientInfo'],
									client
								)
							) {
								setAlert(
									'APS not sent yet. Please send over an APS and try again.'
								);
								setSnackbar(true);
								setSnackbarType('warning');
								setTimeout(() => {
									setAlert('');
								}, 3000);
								closeDocControlHandle();
							} else if (condodocs === true) {
								setAlert(
									'APS must be sent and fully signed before sending ' +
										client.clientEmail +
										' the condo doc forms'
								);
								setSnackbar(true);
								setSnackbarType('warning');
								setTimeout(() => {
									setAlert();
								}, 4000);
								closeDocControlHandle();
							} else if (extraDocs === true) {
								console.log('Create doc in extra doc');
								console.log(
									'ExtraDocsModal open',
									extraDoc.overideRoles
								);
								setCustomFields({});

								setShowExtraDoc(true);
								setShowDocModal(false);
							}
						}}
						data-appcode={client?.appCode}
						data-name={client?.fullName}
						data-clientemail={client?.clientEmail}
						data-salesagentid={client?.salesAgentId}
						data-clientcreatorid={client?.clientCreatorId}
						data-lot={
							client?.documentInformation?.document?.lotActive
								?.lotSelected
								? client.documentInformation?.document
										?.lotActive?.lotSelected
								: ''
						}
					>
						{aps === true && client.documentInformation?.document
							? 'Continue Document'
							: 'Create Document'}
					</Button>
				)}
				{/* TODO: COBROKER FEATURE */}
				{/* {userType === 'cobroker' && (
					<Button
						variant='contained'
						color='primary'
						className={styles.extraDocBtn}
						onClick={(e) => {
							if (aps === true) {
								handleDocument(e);
							} else if (
								condodocs === true &&
								checkIfApsSent(client) &&
								checkIfSendCondoDoc(
									client['expandedClientInfo'],
									client
								) &&
								!checkIfSentDocAlready(
									client['expandedClientInfo'],
									client
								)
							) {
								var currentUserEmail =
									firebase.auth().currentUser.email;
								GetDocumentByInfoCondoDoc(
									firebase,
									client['expandedClientInfo'],
									client,
									ALL_DOCUMENTS.allDocumentTypeInfo
										.condoDocFirebaseInfo,
									ORIGINAL_HREF.originalHREF['access_token'],
									currentUserEmail,
									client.documentInformation.document
										.individualSecondPurchaserDetails
								);
							} else if (
								condodocs == true &&
								checkIfSentDocAlready(
									client['expandedClientInfo'],
									client
								)
							) {
								setAlert(
									'APS not sent yet. Please send over an APS and try again.'
								);
								setTimeout(() => {
									setAlert('');
								}, 3000);
								closeDocControlHandle();
							} else if (condodocs === true) {
								setAlert(
									'APS must be sent and fully signed before sending ' +
										client.clientEmail +
										' the condo doc forms'
								);
								setTimeout(() => {
									setAlert();
								}, 4000);
								closeDocControlHandle();
							} else if (extraDocs === true) {
								console.log('Create doc in extra doc');
								setCustomFields({});
								setShowExtraDoc(true);
								setShowDocModal(false);
							}
						}}
						data-appcode={client?.appCode}
						data-name={client?.fullName}
						data-clientemail={client?.clientEmail}
						data-clientcreatorid={client?.clientCreatorId}
					>
						{aps === true && client.documentInformation?.document
							? 'Continue Document'
							: 'Create Document'}
					</Button>
				)} */}
				{userType === 'admin' && (
					<Button
						variant='contained'
						color='primary'
						className={styles.extraDocBtn}
						onClick={(e) => {
							if (aps === true) {
								handleDoc(
									e.currentTarget.dataset.name,
									e.currentTarget.dataset.clientemail,
									e.currentTarget.dataset.appcode,
									e.currentTarget.dataset.expand,
									lotID
								);
								// history.push({
								//   pathname: '/doc',
								//   state: {
								//     from: 'client',
								//   },
								// });
								handleDocument(e);
							} else if (
								condodocs === true &&
								checkIfApsSent(client) &&
								checkIfSendCondoDoc(
									client['expandedClientInfo'],
									client
								) &&
								!checkIfSentDocAlready(
									client['expandedClientInfo'],
									client
								)
							) {
								var currentUserEmail =
									firebase.auth().currentUser.email;
								GetDocumentByInfoCondoDoc(
									firebase,
									client['expandedClientInfo'],
									client,
									ALL_DOCUMENTS.allDocumentTypeInfo
										.condoDocFirebaseInfo,
									ORIGINAL_HREF.originalHREF['access_token'],
									currentUserEmail,
									client.documentInformation.document
										.individualSecondPurchaserDetails
								);
							} else if (
								condodocs == true &&
								checkIfSentDocAlready(
									client['expandedClientInfo'],
									client
								)
							) {
								setAlert(
									'APS not sent yet. Please send over an APS and try again.'
								);
								setSnackbar(true);
								setSnackbarType('warning');
								setTimeout(() => {
									setAlert('');
								}, 3000);
								closeDocControlHandle();
							} else if (condodocs === true) {
								setAlert(
									'APS must be sent and fully signed before sending ' +
										client.clientEmail +
										' the condo doc forms'
								);
								setSnackbar(true);
								setSnackbarType('warning');
								setTimeout(() => {
									setAlert();
								}, 4000);
								closeDocControlHandle();
							} else if (extraDocs === true) {
								console.log('Create doc in extra doc');
								setCustomFields({});
								setShowExtraDoc(true);
								setShowDocModal(false);
							}
						}}
						data-appcode={client?.appCode}
						data-name={client?.fullName}
						data-clientemail={client?.clientEmail}
						data-clientcreatorid={client?.clientCreatorId}
						data-lot={
							client?.documentInformation?.document?.lotActive
								?.lotSelected
						}
					>
						{aps === true && client.documentInformation?.document
							? 'Continue Document'
							: 'Create Document'}
					</Button>
				)}
				<Button
					variant='contained'
					color='primary'
					className={styles.extraDocBtn}
					onClick={() => {
						if (aps === true) {
							handleAPS('', client);
							closeDocControlHandle();
						} else if (
							condodocs === true &&
							checkIfApsSent(client) &&
							checkIfSendCondoDoc(
								client['expandedClientInfo'],
								client
							)
						) {
							handleCondoDocs('', client);
							closeDocControlHandle();
						} else if (condodocs === true) {
							setAlert(
								'APS must be sent and fully signed before sending ' +
									client.clientEmail +
									' the condo docs are useable.'
							);
							setSnackbar(true);
							setSnackbarType('warning');
							setTimeout(() => {
								setAlert();
							}, 4000);
							closeDocControlHandle();
						} else if (extraDocs === true) {
							handleExtraFiles(client, subject);
						}
						// handleAPS(e, client)
					}}
				>
					View Document
				</Button>

				{(userType === 'superadmin' ||
					userType === 'salesadmin' ||
					userType === 'cobroker') &&
					client?.isForCurrentSalesAgent === true && (
						<Button
							variant='contained'
							color='primary'
							className={styles.extraDocBtn}
							onClick={(e) => {
								if (aps === true) {
									closeDocControlHandle();
									if (
										window.confirm(
											'Editing the document will delete the previous created document. Are you sure you want to do that?'
										)
									) {
										CancelAPSForm(
											firebase,
											client,
											ORIGINAL_HREF.originalHREF[
												'access_token'
											]
										).then((returned) => {
											console.log(
												'Cancel Doc' +
													JSON.stringify(returned)
											);

											if (
												returned.data.success === true
											) {
												setAlert('Canceled Document');
												setSnackbar(true);
												setSnackbarType('warning');
												setTimeout(() => {
													setAlert();
												}, 4000);
											} else {
												setAlert(
													'No Document to cancel'
												);
												setSnackbar(true);
												setSnackbarType('warning');
												setTimeout(() => {
													setAlert();
												}, 4000);
											}
										});
										handleDocument(e);
									}
								} else if (
									condodocs === true &&
									checkIfApsSent(client) &&
									checkIfSendCondoDoc(
										client['expandedClientInfo'],
										client
									)
								) {
									closeDocControlHandle();
									if (
										window.confirm(
											'Editing the document will delete the previous created document. Are you sure you want to do that?'
										)
									) {
										CancelCondoForm(
											firebase,
											client,
											ORIGINAL_HREF.originalHREF[
												'access_token'
											]
										).then((returned) => {
											console.log(
												'Cancel Doc' +
													JSON.stringify(returned)
											);
											var currentUserEmail =
												firebase.auth().currentUser
													.email;
											GetDocumentByInfoCondoDoc(
												firebase,
												client['expandedClientInfo'],
												client,
												ALL_DOCUMENTS
													.allDocumentTypeInfo
													.condoDocFirebaseInfo,
												ORIGINAL_HREF.originalHREF[
													'access_token'
												],
												currentUserEmail,
												client.documentInformation
													.document
													.individualSecondPurchaserDetails
											);

											if (
												returned.data.success === true
											) {
												setAlert('Canceled Document');
												setSnackbar(true);
												setSnackbarType('warning');
												setTimeout(() => {
													setAlert();
												}, 4000);
											} else {
												setAlert(
													'No Document to cancel'
												);
												setSnackbar(true);
												setSnackbarType('warning');
												setTimeout(() => {
													setAlert();
												}, 4000);
											}
										});
									}
								} else if (condodocs === true) {
									setAlert(
										'APS must be sent and fully signed before sending ' +
											client.clientEmail +
											' the condo docs are useable.'
									);
									setSnackbar(true);
									setSnackbarType('warning');
									setTimeout(() => {
										setAlert();
									}, 4000);
									closeDocControlHandle();
								} else if (extraDocs === true) {
									if (
										window.confirm(
											'Editing this document will delete the previous document created. Are you sure you want to continue?'
										)
									) {
										closeDocControlHandle();
										setCustomFields({});
										setShowExtraDoc(true);
										handleManageExtraFormEdit(
											client,
											extraDoc
										);
									}
								}
								// handleAPS(e, client)
							}}
							data-appcode={client?.appCode}
							data-name={client?.fullName}
							data-clientemail={client?.clientEmail}
							data-edit={true}
							data-lot={
								client?.documentInformation?.document?.lotActive
									?.lotSelected
							}
						>
							Edit Document
						</Button>
					)}
				{userType === 'admin' && (
					<Button
						variant='contained'
						color='primary'
						className={styles.extraDocBtn}
						onClick={(e) => {
							if (aps === true) {
								closeDocControlHandle();
								if (
									window.confirm(
										'Editing the document will delete the previous created document. Are you sure you want to do that?'
									)
								) {
									CancelAPSForm(
										firebase,
										client,
										ORIGINAL_HREF.originalHREF[
											'access_token'
										]
									).then((returned) => {
										console.log(
											'Cancel Doc' +
												JSON.stringify(returned)
										);

										if (returned.data.success === true) {
											setAlert('Canceled Document');
											setSnackbar(true);
											setSnackbarType('warning');
											setTimeout(() => {
												setAlert();
											}, 4000);
										} else {
											setAlert('No Document to cancel');
											setSnackbar(true);
											setSnackbarType('warning');
											setTimeout(() => {
												setAlert();
											}, 4000);
										}
									});
									handleDoc(
										e.currentTarget.dataset.name,
										e.currentTarget.dataset.clientemail,
										e.currentTarget.dataset.appcode,
										e.currentTarget.dataset.expand,
										lotID
									);
									//   history.push({
									//     pathname: '/doc',
									//     state: {
									//       from: 'client',
									//     },
									//   });
									handleDocument(e);
								}
							} else if (
								condodocs === true &&
								checkIfApsSent(client) &&
								checkIfSendCondoDoc(
									client['expandedClientInfo'],
									client
								)
							) {
								closeDocControlHandle();
								if (
									window.confirm(
										'Editing the document will delete the previous created document. Are you sure you want to do that?'
									)
								) {
									CancelCondoForm(
										firebase,
										client,
										ORIGINAL_HREF.originalHREF[
											'access_token'
										]
									).then((returned) => {
										console.log(
											'Cancel Doc' +
												JSON.stringify(returned)
										);
										var currentUserEmail =
											firebase.auth().currentUser.email;
										GetDocumentByInfoCondoDoc(
											firebase,
											client['expandedClientInfo'],
											client,
											ALL_DOCUMENTS.allDocumentTypeInfo
												.condoDocFirebaseInfo,
											ORIGINAL_HREF.originalHREF[
												'access_token'
											],
											currentUserEmail,
											client.documentInformation.document
												.individualSecondPurchaserDetails
										);

										if (returned.data.success === true) {
											setAlert('Canceled Document');
											setSnackbar(true);
											setSnackbarType('warning');
											setTimeout(() => {
												setAlert();
											}, 4000);
										} else {
											setAlert('No Document to cancel');
											setSnackbar(true);
											setSnackbarType('warning');
											setTimeout(() => {
												setAlert();
											}, 4000);
										}
									});
								}
							} else if (condodocs === true) {
								setAlert(
									'APS must be sent and fully signed before sending ' +
										client.clientEmail +
										' the condo docs are useable.'
								);
								setSnackbar(true);
								setSnackbarType('warning');
								setTimeout(() => {
									setAlert();
								}, 4000);
								closeDocControlHandle();
							} else if (extraDocs === true) {
								if (
									window.confirm(
										'Editing this document will delete the previous document created. Are you sure you want to continue?'
									)
								) {
									closeDocControlHandle();
									setCustomFields({});
									setShowExtraDoc(true);
									handleManageExtraFormEdit(client, extraDoc);
								}
							}
							// handleAPS(e, client)
						}}
						data-appcode={client?.appCode}
						data-name={client?.fullName}
						data-clientemail={client?.clientEmail}
						data-edit={true}
						data-lot={
							client?.documentInformation?.document?.lotActive
								?.lotSelected
						}
					>
						Edit Document
					</Button>
				)}
				<Button
					variant='contained'
					color='primary'
					className={styles.extraDocBtn}
					onClick={() => {
						if (aps === true) {
							handleAuditTrail(
								client,
								aps,
								condodocs,
								false,
								ALL_DOCUMENTS.allDocumentTypeInfo
									.apsFirebaseInfo.subjectName
							);
							closeDocControlHandle();
						} else if (
							condodocs === true &&
							checkIfApsSent(client) &&
							checkIfSendCondoDoc(
								client['expandedClientInfo'],
								client
							)
						) {
							handleAuditTrail(
								client,
								aps,
								condodocs,
								false,
								ALL_DOCUMENTS.allDocumentTypeInfo
									.condoDocFirebaseInfo.subjectName
							);
							closeDocControlHandle();
						} else if (condodocs === true) {
							setAlert(
								'APS must be sent and fully signed before sending ' +
									client.clientEmail +
									' the condo docs are useable.'
							);
							setSnackbar(true);
							setSnackbarType('warning');
							setTimeout(() => {
								setAlert();
							}, 4000);
							closeDocControlHandle();
						} else if (extraDocs === true) {
							handleAuditTrail(
								client,
								false,
								false,
								extraDocs,
								extraDoc.subjectName
							);
							closeDocControlHandle();
						}
						// handleAPS(e, client)
					}}
				>
					View Audit Trail
				</Button>
				{(userType === 'superadmin' || userType === 'salesadmin') && (
					<Button
						variant='contained'
						color='secondary'
						className={styles.extraDocBtn}
						onClick={() => {
							if (aps === true) {
								//from here we need to delete the document information
								//then we need to also set whatever building that was set to
								//to available
								ClearThisClientDocumentInfo(
									client,
									PROJECT_CODE.projectCode
								);
								handleDeleteAPS('', client);
								closeDocControlHandle();
							} else if (
								condodocs === true &&
								checkIfApsSent(client) &&
								checkIfSendCondoDoc(
									client['expandedClientInfo'],
									client
								)
							) {
								handleDeleteCondoDocs('', client);
								closeDocControlHandle();
							} else if (condodocs === true) {
								setAlert(
									'APS must be sent and fully signed before sending ' +
										client.clientEmail +
										' the condo docs are useable.'
								);
								setSnackbar(true);
								setSnackbarType('warning');
								setTimeout(() => {
									setAlert();
								}, 4000);
								closeDocControlHandle();
							} else if (extraDocs === true) {
								console.log(
									'handleManageExtraFormDelete ' +
										JSON.stringify(extraDoc)
								);
								handleManageExtraFormDelete(client, extraDoc);
							}
							// handleAPS(e, client)
						}}
					>
						Delete
					</Button>
				)}
				{userType === 'admin' && (
					<Button
						variant='contained'
						color='secondary'
						className={styles.extraDocBtn}
						onClick={() => {
							if (aps === true) {
								//from here we need to delete the document information
								//then we need to also set whatever building that was set to
								//to available
								ClearThisClientDocumentInfo(
									client,
									PROJECT_CODE.projectCode
								);
								handleDeleteAPS('', client);
								closeDocControlHandle();
							} else if (
								condodocs === true &&
								checkIfApsSent(client) &&
								checkIfSendCondoDoc(
									client['expandedClientInfo'],
									client
								)
							) {
								handleDeleteCondoDocs('', client);
								closeDocControlHandle();
							} else if (condodocs === true) {
								setAlert(
									'APS must be sent and fully signed before sending ' +
										client.clientEmail +
										' the condo docs are useable.'
								);
								setSnackbar(true);
								setSnackbarType('warning');
								setTimeout(() => {
									setAlert();
								}, 4000);
								closeDocControlHandle();
							} else if (extraDocs === true) {
								console.log(
									'handleManageExtraFormDelete ' +
										JSON.stringify(extraDoc)
								);
								handleManageExtraFormDelete(client, extraDoc);
							}
							// handleAPS(e, client)
						}}
					>
						Delete
					</Button>
				)}
			</div>
		);
	};

	const handleAddClient = () => {
		//add error message for add client
		var phoneRef =
			/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

		if (
			clientEmail === '' ||
			clientName === '' ||
			clientPhoneNumber === ''
		) {
			setAlertModal('Please fill all the information in the fields.');
			setSnackbar(true);
			setTimeout(() => {
				setAlertModal('');
			}, 4000);
		} else if (validateEmail(clientEmail) !== true) {
			setAlertModal('The email is invalid.');
			setSnackbar(true);
			setTimeout(() => {
				setAlertModal('');
			}, 4000);
		} else if (!phoneRef.test(clientPhoneNumber)) {
			setAlertModal('The phone number is invalid.');
			setSnackbar(true);
			setTimeout(() => {
				setAlertModal('');
			}, 4000);
		} else {
			setLoading(true);
			AddNewClient(
				clientName,
				clientEmail,
				clientPhoneNumber,
				(returned) => {
					setAlert(returned);
					setSnackbar(true);
					setTimeout(() => {
						setAlert('');
					}, 4000);
				},
				(returned) => {
					setSnackbarType(returned);
				},
				coBrokersSalesAgent
			).then(() => {
				setFormData({
					clientEmail: '',
					clientName: '',
					clientPhoneNumber: '',
				});
				closeModalHandler();
			});
		}
	};

	const handleAddDocument = () => {
		// Code for adding the documents comes here!
	};

	const useStyles = makeStyles({
		tableCell: {
			fontSize: '14px',
			borderBottom: '3px solid #dcdcdc',
			fontWeight: 'bold',
		},
		docHeader: {
			textAlignLast: 'center',
		},
		progressTab: {
			backgroundColor: '#F1F5F8',
			marginBottom: '1em',
			boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
			width: '34em',
		},
		expandContent: {
			transition: 'all .35s',
		},
		extraDocBtn: {
			marginBottom: '1em',
			marginRight: '10px',
		},
		eventContent: {
			width: '5em',
		},
	});

	const StyledTabs = withStyles({
		indicator: {
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: 'transparent',
		},
	})((props) => (
		<Tabs
			{...props}
			variant='scrollable'
			scrollButtons={'on'}
			TabIndicatorProps={{ children: <span /> }}
		/>
	));

	const StyledTab = withStyles((theme) => ({
		root: {
			textTransform: 'none',
			color: '#636D73',

			'&.Mui-selected': {
				backgroundColor: '#FFFFFF',
				boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
				borderRadius: '8px',
				color: '#2662F0',
			},
		},
	}))((props) => <Tab {...props} />);

	const styles = useStyles();

	//click function APS Form
	const handleAPS = async (e, client) => {
		console.log('You clicked on APS');

		var dataJson = {
			appcode: client.appCode,
			keyvalue: client.keyValue,
			salesagentpointer: client.salesAgentPointer,
			name: client.fullName,
			clientemail: client.clientEmail,
		};

		console.log('handle APS view document', dataJson);

		var currentUserId = firebase.auth().currentUser.uid;
		setDocLoading(true);
		await GetClientAPSFiles(
			dataJson,
			currentUserId,
			ORIGINAL_HREF.originalHREF['access_token']
		).then(async (returned) => {
			if (returned.data.status === 'complete') {
				console.log('handleAPS pdf', returned.data.pdfPath);
				setDocLoading(true);

				if (returned.data.pdfPath) {
					await firebase
						.database()
						.ref(returned.data.pdfPath)
						.child('base64pdf')
						.on('value', (snapshot) => {
							//then we view the pdf in here

							console.log(
								'handleAPS in the snapshot',
								snapshot?.val()
							);
							if (
								snapshot.val() !== undefined &&
								snapshot.val() !== null &&
								snapshot.val()
							) {
								var isReady = snapshot.val();

								if (isReady) {
									window.open(
										isReady,
										'View APS',
										'toolbar=no,resizable=yes,location=yes,menubar=yes'
									);
									setDocLoading(false);
								}
							}
						});
				}
			} else if (returned.data.status === 'no_document') {
				setAlert('Document has not been sent yet.');
				setSnackbar(true);
				setSnackbarType('warning');
				setTimeout(() => {
					setAlert();
				}, 4000);
				setDocLoading(false);
				//still_processing
			} else if (returned.data.status === 'still_processing') {
				setAlert('Document is still processing try again later.');
				setSnackbar(true);
				setSnackbarType('warning');
				setTimeout(() => {
					setAlert();
				}, 4000);
				setDocLoading(false);
				//still_processing
			}
		});
	};

	//click function Condo Docs
	const handleCondoDocs = async (e, client) => {
		console.log('You clicked on Condo Docs');

		var dataJson = {
			appcode: client.appCode,
			keyvalue: client.keyValue,
			salesagentpointer: client.salesAgentPointer,
			name: client.fullName,
			clientemail: client.clientEmail,
		};

		var currentUserId = firebase.auth().currentUser.uid;

		setDocLoading(true);
		await GetClientCondoFiles(
			dataJson,
			currentUserId,
			ORIGINAL_HREF.originalHREF['access_token']
		).then((returned) => {
			if (returned.data.status === 'complete') {
				console.log(JSON.stringify(returned.data.signatureRequestId));
				console.log('pdf ' + returned.data.pdfPath);

				firebase
					.database()
					.ref(returned.data.pdfPath)
					.child('base64pdf')
					.on('value', (snapshot) => {
						//then we view the pdf in here
						if (
							snapshot.val() !== undefined &&
							snapshot.val() !== null &&
							snapshot.val()
						) {
							var isReady = snapshot.val();
							console.log('is ready ?' + isReady);

							if (isReady) {
								window.open(
									isReady,
									'View Condo Docs',
									'toolbar=no,resizable=yes,location=yes,menubar=yes'
								);
								setDocLoading(false);
								return false;
							}
						}
					});
			} else if (returned.data.status === 'no_document') {
				setAlert('Document has not been sent yet.');
				setSnackbar(true);
				setSnackbarType('warning');
				setTimeout(() => {
					setAlert();
				}, 4000);
				setDocLoading(false);
				//still_processing
			} else if (returned.data.status === 'still_processing') {
				setAlert('Document is still processing try again later.');
				setSnackbar(true);
				setSnackbarType('warning');
				setTimeout(() => {
					setAlert();
				}, 4000);
				setDocLoading(false);
				//still_processing
			}
		});
	};

	//click function EFT Forms

	const handleDeleteAPS = async (e, client) => {
		console.log(' handleDeleteAPS ');
		if (window.confirm('Are you sure you want to cancel this document?')) {
			CancelAPSForm(
				firebase,
				client,
				ORIGINAL_HREF.originalHREF['access_token']
			).then((returned) => {
				console.log('handleDeleteAPS Cancel Doc', returned);

				if (returned.data.success === true) {
					setAlert('Canceled Document');
					setSnackbar(true);
					setSnackbarType('warning');
					setTimeout(() => {
						setAlert();
					}, 4000);
				} else if (
					returned.data.success === false &&
					userType === 'superadmin'
				) {
					setAlert('Canceled Document');
					setSnackbar(true);
					setSnackbarType('warning');
					setTimeout(() => {
						setAlert();
					}, 4000);
				} else {
					setAlert('No Document to cancel');
					setSnackbar(true);
					setSnackbarType('warning');
					setTimeout(() => {
						setAlert();
					}, 4000);
				}
			});
		} else {
			return null;
		}
	};

	const handleDeleteCondoDocs = async (e, client) => {
		console.log(' handleDeleteCondoDocs ');
		if (window.confirm('Are you sure you want to cancel this document?')) {
			CancelCondoForm(
				firebase,
				client,
				ORIGINAL_HREF.originalHREF['access_token']
			).then((returned) => {
				console.log('Cancel Doc' + JSON.stringify(returned));

				if (returned.data.success === true) {
					setAlert('Canceled Document');
					setSnackbar(true);
					setSnackbarType('warning');
					setTimeout(() => {
						setAlert();
					}, 4000);
				} else {
					setAlert('No Document to cancel');
					setSnackbar(true);
					setSnackbarType('warning');
					setTimeout(() => {
						setAlert();
					}, 4000);
				}
			});
		} else {
			return null;
		}
	};

	const handleDeleteEFTForms = async (e, client) => {
		if (window.confirm('Are you sure you want to cancel this document?')) {
			console.log(' handleDeleteEFTForms ');
		} else {
			return null;
		}
	};

	const handleShowAPSControl = (client) => {
		setShowDocModal({ ...showDocModal, aps: true, currentClient: client });
	};

	const handleShowCondoDocsControl = (client) => {
		setShowDocModal({
			...showDocModal,
			condodocs: true,
			currentClient: client,
		});
	};

	const handleShowExtraDocControls = (client, _extraDoc, subject) => {
		console.log('handleShowExtraDocControls this is subject: ', _extraDoc);
		setShowDocModal({
			...showDocModal,
			extraDocs: true,
			currentClient: client,
			extraDoc: _extraDoc,
			subject: subject,
			aps: false,
			condodocs: false,
		});
	};

	const handleClickForm = (e, client, _extraDoc, subject) => {
		var formName = e.currentTarget.dataset.name;
		console.log('formName: ', formName);

		//click function for the forms
		if (formName === allDocumentNames[0]) {
			// handleAPS(e, client);
			handleShowAPSControl(client);
		} else if (formName === allDocumentNames[1]) {
			// handleCondoDocs(e, client);
			handleShowCondoDocsControl(client);
		} else {
			console.log(
				'handleClickForm -> handleShowExtraDocControls: ',
				subject
			);
			handleShowExtraDocControls(client, _extraDoc, subject);
		}
	};

	// Delete form and edit

	const handleManageExtraFormEdit = (client, extraDoc) => {
		console.log('handleManageExtraFormEdit ' + JSON.stringify(extraDoc));

		handleManageExtraFormDelete(client, extraDoc);

		console.log('Create doc in extra doc');
		setCustomFields({});
		setShowExtraDoc(true);
		setShowDocModal(false);
	};

	const handleManageExtraFormDelete = (client, extraDoc) => {
		console.log('handleManageExtraFormDelete ' + JSON.stringify(extraDoc));

		CancelExtraForm(
			firebase,
			client,
			ORIGINAL_HREF.originalHREF['access_token'],
			extraDoc.subjectName
		).then((returned) => {
			console.log('Cancel Doc' + JSON.stringify(returned));

			if (returned.data.success === true) {
				setAlert('Canceled Document');
				setSnackbar(true);
				setSnackbarType('warning');
				setTimeout(() => {
					setAlert();
				}, 4000);
			} else {
				setAlert('No Document to cancel');
				setSnackbar(true);
				setSnackbarType('warning');
				setTimeout(() => {
					setAlert();
				}, 4000);
			}
		});
	};

	const handleChange = (e) => {
		setSearchField(e.target.value);
	};

	const checkIfSendCondoDoc = (expandedClient, client) => {
		if (expandedClient.data.status === 'condodoc') {
			return true;
		} else if (expandedClient.data.status === 'aps') {
			var signatureObjBuilder =
				expandedClient.data.latest_update.signatures[
					expandedClient.data.latest_update.signatures.length - 1
				];
			if (signatureObjBuilder.status_code === 'signed') {
				return true;
			}
		} else {
			return false;
		}
	};

	const checkIfSentDocAlready = (expandedClient, client) => {
		if (expandedClient.data.status === 'aps') {
			return false;
		} else {
			return true;
		}
	};

	const styleActionBtns = (expandedClient, formName) => {
		console.log('STYLING ACTION BUTTONS ' + formName);
		var statusCode;
		if (formName === 'Condo Docs') {
			var allSigners = expandedClient.data.latest_update.signatures;
			if (
				formName !== 'APS' &&
				expandedClient.data.status === 'condodoc'
			) {
				// REMOVED ADMIN AND BUILDER NO LONGER USING THEM ON CONDO DOC, only yellow or green now
				console.log('STYLING ACTION BUTTONS 2' + formName);
				if (
					allSigners[allSigners.length - 1].status_code === 'signed' //Witness
				) {
					console.log('STYLING ACTION BUTTONS 3' + formName);
					return { backgroundColor: '#52DC19', color: '#FFFFFF' }; //green
				} else if (
					allSigners[allSigners.length - 1].status_code ===
					'awaiting_signature'
				) {
					return { backgroundColor: '#FFD84E' }; //yellow
				}
			} else if (expandedClient.data.status === 'condodoc') {
				return { backgroundColor: '#52DC19', color: '#FFFFFF' };
			} else {
				return { backgroundColor: '#F1F5F8', color: '#000000' };
			}
		} else if (formName === 'APS') {
			var allSigners = expandedClient.data.latest_update.signatures;
			if (
				formName === 'APS' &&
				expandedClient.data.status !== 'condodoc'
			) {
				if (allSigners[1]?.signer_role === 'Second Purchaser') {
					if (
						allSigners[0]?.status_code === 'signed' && //Purchaser
						allSigners[1]?.status_code === 'signed' && //Second Purchaser
						allSigners[2]?.status_code === 'signed' && //Admin
						allSigners[3]?.status_code === 'signed' //Builder
					) {
						console.log('Im here 3');
						return { backgroundColor: '#52DC19', color: '#FFFFFF' };
					} else if (
						allSigners[0]?.status_code === 'signed' && //Purchaser
						allSigners[1]?.status_code === 'signed' && //Second Purchaser
						allSigners[2]?.status_code === 'signed' // admin
					) {
						console.log('Im here 2');
						return { backgroundColor: '#FFD84E' };
					} else if (
						allSigners[0]?.status_code === 'signed' && //Purchaser
						allSigners[1]?.status_code === 'signed' //Second Purchaser
					) {
						console.log('Im here 1');
						return { backgroundColor: '#FF8A27' };
					} else {
						console.log('Im here 4');
						return { backgroundColor: '#FFD84E' };
					}
				} else {
					console.log('Im here < 4');
					if (
						allSigners[0]?.status_code === 'signed' && //client
						allSigners[1]?.status_code === 'signed' && //admin
						allSigners[2]?.status_code === 'signed' //builder
					) {
						console.log('Im here 3');
						return { backgroundColor: '#52DC19', color: '#FFFFFF' };
					} else if (
						allSigners[0]?.status_code === 'signed' && //client
						allSigners[1]?.status_code === 'signed' //admin
					) {
						console.log('Im here 2');
						return { backgroundColor: '#FFD84E' };
					} else if (
						allSigners[0]?.status_code === 'signed' //client
					) {
						console.log('Im here 1');
						return { backgroundColor: '#FF8A27' };
					} else {
						console.log('Im here 4');
						return { backgroundColor: '#FFD84E' };
					}
				}
			} else if (expandedClient.data.status === 'condodoc') {
				return { backgroundColor: '#52DC19', color: '#FFFFFF' }; //blue
			} else {
				return { backgroundColor: '#F1F5F8', color: '#000000' }; //grey (default color)
			}
		}
	};

	//styling for the status color for client
	const styleClientStatusColor = (expandedClient, formName) => {
		var allSigners = expandedClient.data.latest_update?.signatures;
		if (formName === 'APS') {
			if (expandedClient.data.status !== 'condodoc') {
				//has second purchaser
				if (allSigners[1]?.signer_role === 'Second Purchaser') {
					//client and client 2
					if (
						allSigners[0]?.status_code === 'signed' && //Purchaser
						allSigners[1]?.status_code === 'signed' //Second Purchaser
					) {
						return { stroke: '#34D1BF' }; //green
					} else if (allSigners[1] !== 'signed') {
						//#FF8A27
						return { stroke: '#FF8A27' }; //not green
					}
				} else {
					if (
						allSigners[0]?.status_code === 'signed' //Purchaser
					) {
						return { stroke: '#34D1BF' }; //green
					}
				}
			} else if (expandedClient.data.status === 'condodoc') {
				return { stroke: '#34D1BF' };
			}
		} else if (formName === 'Condo Docs') {
			if (expandedClient.data.status === 'condodoc') {
				//has second purchaser

				console.log(
					'allSigners[allSigners.length - 1]',
					allSigners[allSigners.length - 2]
				);
				//@TODO line 1942
				if (allSigners[1]?.signer_role === 'Second Purchaser') {
					if (
						allSigners[0]?.status_code === 'signed' //Purchaser
					) {
						return { stroke: '#34D1BF' }; //green
					} else if (
						allSigners[0]?.status_code === 'signed' //Purchaser
					) {
						return { stroke: '#FF8A27' }; //green
					} else {
						return { stroke: '#FF8A27' }; //green
					}
				} else {
					if (
						allSigners[0]?.status_code === 'signed' //Witness
					) {
						return { stroke: '#34D1BF' }; //green
					} else {
						return { stroke: '#FF8A27' }; //green
					}
					// else if(allSigners[ allSigners.length - 1].status_code !== 'signed'){
					// 	return { stroke: '#34D1BF' }; //green
					// }
				}
			}
		}
	};

	//styling for the status color for builder
	const styleBuilderStatusColor = (expandedClient, formName) => {
		if (formName === 'APS') {
			var allSigners = expandedClient.data.latest_update?.signatures;
			if (expandedClient.data.status !== 'condodoc') {
				if (
					allSigners[allSigners.length - 1]?.status_code === 'signed'
				) {
					return { stroke: '#34D1BF' };
				}
			} else if (expandedClient.data.status === 'condodoc') {
				return { stroke: '#34D1BF' };
			}
		} else if (formName === 'Condo Docs') {
			var allSigners = expandedClient.data.latest_update?.signatures;

			if (expandedClient.data.status === 'condodoc') {
				console.log('asfdsakfdf', allSigners);
				if (allSigners[1]?.signer_role === 'Second Purchaser') {
					if (
						allSigners[1]?.status_code === 'signed' //Second Purchaser
					) {
						return { stroke: '#34D1BF' }; //green
					} else if (
						allSigners[1]?.status_code === 'signed' //Second Purchaser
					) {
						return { stroke: '#FF8A27' }; //green
					} else {
						return { stroke: '#FF8A27' }; //green
					}
				} else {
					if (
						allSigners[allSigners.length - 1]?.status_code ===
						'signed' //Witness
					) {
						return { stroke: '#34D1BF' }; //green
					} else {
						return { stroke: '#FF8A27' }; //green
					}
					// else if(allSigners[ allSigners.length - 1].status_code !== 'signed'){
					// 	return { stroke: '#34D1BF' }; //green
					// }
				}
			}
		}
	};

	const handleDocumentInformation = (client) => {
		var documentObj = client?.documentInformation?.document;

		var individualsObj = documentObj?.individualDetails;
		var lawyerObj = documentObj?.lawyerDetails;
		var coBrokerObj = documentObj?.coBrokerDetails;
		var mortgageObj = documentObj?.mortgageDetails;
		var lotDetails = documentObj?.lotActive;
		var elevationId = documentObj?.elevationId;

		console.log('handleDocumentInformation ', JSON.stringify(documentObj));
		var lotObj = { ...lotDetails, elevationId: elevationId };

		var viewObj = {
			individualsObj: individualsObj,
			lawyerObj: lawyerObj,
			coBrokerObj: coBrokerObj,
			mortgageObj: mortgageObj,
			lotObj: lotObj,
		};

		if (documentObj === undefined) {
			setShowDocInfo(false);
			setAlert('No document has been sent yet.');
			setSnackbar(true);
			setSnackbarType('warning');
			setTimeout(() => {
				setAlert();
			}, 3000);
		} else {
			setDocInformation(viewObj);
			setClientJson(client);
		}

		console.log('viewObj: ', JSON.stringify(viewObj.lotObj));
	};

	const handleAuditTrail = (client, aps, condodoc, extraDoc, subjectName) => {
		if (client.documentInformation?.signatureRequests) {
			function arrUnique(arr) {
				var cleaned = [];
				arr.forEach(function (itm) {
					var unique = true;
					cleaned.forEach(function (itm2) {
						if (_.isEqual(itm, itm2)) unique = false;
					});
					if (unique) cleaned.push(itm);
				});
				return cleaned;
			}

			var eventAuditObj;
			var signatureDetailsObj;
			var signatureDetailsArr = [];
			var eventAuditArr = [];

			var whereToFindRequest = '';

			if (extraDoc === true) {
				whereToFindRequest = 'signatureRequestsExtras';
			} else {
				whereToFindRequest = 'signatureRequests';
			}

			if (client?.documentInformation?.signatureRequests) {
				var objBuilder =
					client?.documentInformation[whereToFindRequest];

				console.log('objbuilder: ' + JSON.stringify(objBuilder));

				// console.log()

				// console.log('objBuilder keys' + Object.keys(objBuilder));

				var signatureRequestsKeys =
					objBuilder && Object.keys(objBuilder);

				console.log(
					subjectName +
						' Signature Request Keys ' +
						signatureRequestsKeys
				);

				signatureRequestsKeys?.forEach((key) => {
					var signatureUpdateObj = objBuilder[key].signatureUpdates;

					if (signatureUpdateObj) {
						var signatureUpdateObjKeys =
							signatureUpdateObj &&
							Object.keys(signatureUpdateObj);

						console.log(
							'signatureUpdateObjKeys ' +
								JSON.stringify(signatureUpdateObjKeys)
						);
						if (
							signatureUpdateObj[signatureUpdateObjKeys[0]]
								?.signature_request.subject === subjectName &&
							(aps === true ||
								condodoc === true ||
								extraDoc === true)
						) {
							signatureUpdateObjKeys?.forEach((key) => {
								var signatureRequestObj =
									signatureUpdateObj[key].signature_request
										.signatures;

								var signatureRequestKey =
									Object.keys(signatureRequestObj);

								console.log(
									'signatureRequestKey  ' +
										signatureRequestKey
								);

								var theseSignatureDetails = [];
								signatureRequestKey.forEach((key) => {
									var signerEmail =
										signatureRequestObj[key]
											.signer_email_address;
									var signerStatus =
										signatureRequestObj[key].status_code;
									var signerRole =
										signatureRequestObj[key].signer_role;

									signatureDetailsObj = {
										signerEmail: signerEmail,
										signerStatus: signerStatus,
										signerRole: signerRole,
									};

									console.log(
										'signatureDetailsObj ' +
											signatureDetailsObj
									);
									// signatureDetailsArr.push(signatureDetailsObj);
									theseSignatureDetails.push(
										signatureDetailsObj
									);
								});

								console.log(
									'signatureRequestObj ' + signatureRequestObj
								);
								var eventObj = signatureUpdateObj[key].event;

								console.log(
									'eventObj : ' + JSON.stringify(eventObj)
								);
								var eventType = eventObj.event_type;
								var eventTime = eventObj.event_time;

								eventAuditObj = {
									eventType: eventType,
									eventTime: eventTime,
									signatureDetails: theseSignatureDetails,
								};

								eventAuditArr.push(eventAuditObj);

								console.log(
									'eventAuditArr ' +
										JSON.stringify(eventAuditArr)
								);
							});
						}
					}
				});

				console.log(
					'eventBuildAuditArr: ' + JSON.stringify(eventAuditArr)
				);

				setAuditTrail(arrUnique(eventAuditArr));
				setSignatureDetails(arrUnique(signatureDetailsArr));
				setShowAuditTrail(true);
			}
		} else {
			setAlert(
				'A document should be sent over in order to view the audit trail.'
			);
			setSnackbar(true);
			setSnackbarType('warning');
			setTimeout(() => {
				setAlert('');
			}, 4000);
		}
	};
	const getCondoDocUrl = async (expandedClient, client) => {
		const getDoc = firebase
			.functions()
			.httpsCallable('HelloSignUnclaimedDraftCondoDoc');
		// var client_email = data.clientEmail;
		// var client_first_name_ = data.buyerFirstName;
		// var dataJson = {
		// 	appcode: client.appCode,
		// 	keyvalue: client.keyValue,
		// 	salesagentpointer: client.salesAgentPointer,
		// 	name: client.fullName,
		// 	clientemail: client.clientEmail
		// }

		console.log('Sending lot id ' + lotID);
		var clientNamesSplit = client.fullName.split(' ');
		var allInfoCombined = {
			clientEmail: client.clientEmail,
			buyerFirstName: ' ',
			buyerSecondName: client.fullName,
			buyer_lot_number: lotID,
		};

		const displayHelloDoc = (signUrl) => {
			console.log('signurl: ' + signUrl);
			helloClient.open(signUrl, {
				skipDomainVerification: true,
				clientId: CLIENT_ID.clientId,
			});
		};

		getDoc(allInfoCombined)
			.then((result) => {
				//setLoading(false);
				console.log(
					'doc result: ' + JSON.stringify(result['data']['claim_url'])
				);
				displayHelloDoc(result['data']['claim_url']);

				SaveClientSignatureRequestInfo(
					firebase,
					result['data'],
					client.clientEmail
				);
			})
			.catch(function (error) {
				console.log('Error ' + error);
			});
	};

	// const jsxSendCondoDoc = (expandedClient, client) => {
	//   var currentUserEmail = firebase.auth().currentUser.email;
	//   return (
	//     <button
	//       className='btn btn-primary start_condo_btn'
	//       onClick={() => {
	//         GetDocumentByInfoCondoDoc(
	//           firebase,
	//           expandedClient,
	//           client,
	//           ALL_DOCUMENTS.allDocumentTypeInfo.condoDocFirebaseInfo,
	//           ORIGINAL_HREF.originalHREF['access_token'],
	//           currentUserEmail,
	//           client.documentInformation.document.individualSecondPurchaserDetails
	//         );
	//       }}
	//     >
	//       Start Condo Doc
	//     </button>
	//   );
	// };

	const jsxForExpandedClient = (expandedClient, client) => {
		//<p>{expandedClient.data.latest_update.subject}</p>
		//allDocumentNames
		console.log('jsxForExpandedClient ', expandedClient);
		if (expandedClient?.data) {
			if (expandedClient?.data.status === 'none') {
				return (
					<>
						<TableCell colSpan={1} style={styles.docContent}>
							<div className='d-flex'>
								<div className='form_btn_wrapper'>
									{allDocumentNames?.map((formName) => {
										return (
											// <TableCell>
											<div className='d-flex button_status_group'>
												<button
													data-name={formName}
													onClick={(e) =>
														handleClickForm(
															e,
															client
														)
													}
													className='btn btn-client-actions'
												>
													{formName}
												</button>
												<div className='status_wrapper'>
													<div className='status_ticker_wrap'>
														<FiberManualRecordOutlinedIcon className='status_signed' />
														<span>Client</span>
													</div>
													<div className='status_ticker_wrap'>
														<FiberManualRecordOutlinedIcon className='status_signed' />
														<span>Builder</span>
													</div>
												</div>
											</div>
										);
									})}
									<button
										data-name={'+ DOCS'}
										onClick={() => {
											setCustomSigners({});
											console.log(
												'Client Open modal custom signer ',
												customSigners
											);
											setShowAddDoc({
												visible: true,
												client: client,
											});
										}}
										style={{
											...styleExtraDocMainButton(client),
										}}
										className='btn btn-client-actions'
									>
										+ DOCS
									</button>
								</div>
							</div>
						</TableCell>
					</>
				);
			} else if (expandedClient?.data.status === 'waiting') {
				var setColorAps;
				var setColorCondoDoc;
				if (expandedClient.data.waitingOn === 'aps') {
					setColorAps = { backgroundColor: '#FFD84E' };
					setColorCondoDoc = {
						backgroundColor: '#F1F5F8',
						color: '#000000',
					}; //grey (default color)
				} else if (expandedClient.data.waitingOn === 'condodoc') {
					setColorCondoDoc = { backgroundColor: '#FFD84E' };
					setColorAps = {
						backgroundColor: '#52DC19',
						color: '#FFFFFF',
					}; //Blue
				}
				return (
					<>
						<TableCell colSpan={1} style={styles.docContent}>
							<div className='d-flex'>
								<div className='form_btn_wrapper'>
									{allDocumentNames?.map((formName) => {
										var setColor;
										if (formName === 'APS') {
											setColor = setColorAps;
										} else {
											setColor = setColorCondoDoc;
										}
										return (
											// <TableCell>
											<div className='d-flex button_status_group'>
												<button
													data-name={formName}
													onClick={(e) =>
														handleClickForm(
															e,
															client
														)
													}
													className='btn btn-client-actions'
													style={setColor}
												>
													{formName}
												</button>
												<div className='status_wrapper'>
													<div className='status_ticker_wrap'>
														<FiberManualRecordOutlinedIcon className='status_signed' />
														<span>Client</span>
													</div>
													<div className='status_ticker_wrap'>
														<FiberManualRecordOutlinedIcon className='status_signed' />
														<span>Builder</span>
													</div>
												</div>
											</div>
										);
									})}
									<button
										data-name={'+ DOCS'}
										onClick={() => {
											setCustomSigners({});
											console.log(
												'Client Open modal custom signer ',
												customSigners
											);
											setShowAddDoc({
												visible: true,
												client: client,
											});
										}}
										style={{
											...styleExtraDocMainButton(client),
										}}
										className='btn btn-client-actions'
									>
										+ DOCS
									</button>
								</div>
							</div>
						</TableCell>
					</>
				);
			} else if (
				expandedClient?.data.status !== 'waiting' &&
				expandedClient?.data.latest_update.signatures
			) {
				return (
					<>
						<TableCell colSpan={1} style={styles.docContent}>
							<div className='d-flex'>
								<div className='form_btn_wrapper'>
									{allDocumentNames?.map((formName) => {
										return (
											// <TableCell>
											<div className='d-flex button_status_group'>
												<button
													data-name={formName}
													onClick={(e) =>
														handleClickForm(
															e,
															client
														)
													}
													className='btn btn-client-actions'
													style={{
														...styleActionBtns(
															expandedClient,
															formName
														),
													}}
												>
													{formName}
												</button>
												<div className='status_wrapper'>
													<div className='status_ticker_wrap'>
														<FiberManualRecordOutlinedIcon
															className='status_signed'
															style={{
																...styleClientStatusColor(
																	expandedClient,
																	formName
																),
															}}
														/>
														<span>Client</span>
													</div>
													<div className='status_ticker_wrap'>
														<FiberManualRecordOutlinedIcon
															className='status_signed'
															style={{
																...styleBuilderStatusColor(
																	expandedClient,
																	formName
																),
															}}
														/>
														<span>Builder</span>
													</div>
												</div>
											</div>
										);
									})}
									<button
										data-name={'+ DOCS'}
										onClick={() => {
											setCustomSigners({});
											console.log(
												'Client Open modal custom signer ',
												customSigners
											);
											setShowAddDoc({
												visible: true,
												client: client,
											});
										}}
										style={{
											...styleExtraDocMainButton(client),
										}}
										className='btn btn-client-actions'
									>
										+ DOCS
									</button>
								</div>
							</div>
						</TableCell>
					</>
				);
			}
		}
	};

	const styleClientStatusColorExtra = (
		expandedClient,
		client,
		subjectName
	) => {
		var signatureObj;
		var subjectNameNode;
		var signatureRequestsExtras =
			client?.documentInformation?.signatureRequestsExtras;

		var signatureRequestsExtrasKeys =
			signatureRequestsExtras && Object.keys(signatureRequestsExtras);

		console.log(
			'signatureRequestsExtrasKeys: ' +
				JSON.stringify(signatureRequestsExtrasKeys)
		);

		var endColor;

		console.log(
			'signatureRequestsExtrasKeys?.length 1757',
			signatureRequestsExtrasKeys?.length
		);

		for (var i = 0; i <= signatureRequestsExtrasKeys?.length - 1; i++) {
			console.log('i index 1762', i);
			console.log(
				'signatureRequestsExtras[signatureRequestsExtrasKeys[i]] 1757:',
				signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
			);
			if (
				signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
					?.signatureUpdates
			) {
				var signatureUpdates =
					signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
						?.signatureUpdates;

				var signatureUpdatesKeys =
					signatureUpdates && Object.keys(signatureUpdates);

				subjectNameNode =
					signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
						?.subject;

				signatureObj =
					signatureUpdates &&
					signatureUpdates[
						signatureUpdatesKeys[signatureUpdatesKeys?.length - 1]
					]?.signature_request.signatures;

				console.log(
					'signatureUpdatesKeys?.length - 1 1787',
					signatureUpdatesKeys?.length - 1
				);

				var eventType =
					signatureUpdates &&
					signatureUpdates[
						signatureUpdatesKeys[signatureUpdatesKeys?.length - 1]
					]?.event.event_type;

				if (subjectName === subjectNameNode && signatureObj) {
					console.log('is it equal?', true);
					if (signatureObj[2]?.signer_role === 'Second Purchaser') {
						console.log('I am in second purchaser');
						if (
							signatureObj[0].status_code === 'signed' && //Purchaser
							signatureObj[1].status_code === 'signed' && //Witness
							signatureObj[2].status_code === 'signed' && //Second Purchaser
							signatureObj[3].status_code === 'signed' //Second Witness
						) {
							console.log(subjectName + 'endColor 1808 iffff');
							endColor = { stroke: '#34D1BF' };
						}
					} else if (signatureObj.length === 4) {
						if (
							signatureObj[0].status_code === 'signed' && //Purchaser
							signatureObj[1].status_code === 'signed' //Witness
						) {
							console.log(subjectName + 'endColor 1816 iffff');
							endColor = { stroke: '#34D1BF' };
						}
					} else if (signatureObj.length === 5) {
						if (
							signatureObj[signatureObj.length - 1]
								.status_code === 'signed'
						) {
							endColor = { stroke: '#34D1BF' };
						} else {
							endColor = { stroke: '#f17105' };
						}
					} else if (signatureObj[2]?.signer_role) {
						if (signatureObj[0].status_code === 'signed') {
							console.log(subjectName + 'endColor 1808 elsseeee');
							endColor = { stroke: '#34D1BF' };
						} else {
							endColor = { stroke: '#f17105' };
						}
					} else {
						if (
							signatureObj[signatureObj.length - 1]
								.status_code === 'signed'
						) {
							endColor = { stroke: '#34D1BF' };
						} else {
							endColor = { stroke: '#f17105' };
						}
					}
				}
			}
			console.log(subjectName + ' : endColor 1812: ', endColor);
		}
		return endColor;
	};

	const styleBuilderStatusColorExtra = (
		expandedClient,
		client,
		subjectName
	) => {
		var signatureObj;
		var subjectNameNode;
		var signatureRequestsExtras =
			client?.documentInformation?.signatureRequestsExtras;

		var signatureRequestsExtrasKeys =
			signatureRequestsExtras && Object.keys(signatureRequestsExtras);

		var endColor;

		console.log(
			'signatureRequestsExtrasKeys: ' +
				JSON.stringify(signatureRequestsExtrasKeys)
		);
		for (var i = 0; i <= signatureRequestsExtrasKeys?.length - 1; i++) {
			if (
				signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
					?.signatureUpdates
			) {
				var signatureUpdates =
					signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
						?.signatureUpdates;

				var signatureUpdatesKeys =
					signatureUpdates && Object.keys(signatureUpdates);

				subjectNameNode =
					signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
						?.subject;

				signatureObj =
					signatureUpdates &&
					signatureUpdates[
						signatureUpdatesKeys[signatureUpdatesKeys?.length - 1]
					]?.signature_request.signatures;

				var eventType =
					signatureUpdates &&
					signatureUpdates[
						signatureUpdatesKeys[signatureUpdatesKeys?.length - 1]
					]?.event.event_type;

				if (
					subjectNameNode === subjectName &&
					eventType !== 'signature_request_canceled'
				) {
					if (
						signatureObj[signatureObj.length - 1].status_code ===
						'signed'
					) {
						endColor = { stroke: '#34D1BF' };
					} else {
						endColor = { stroke: '#f17105' };
					}
				}
			}
		}

		return endColor;
	};

	const styleExtraDocMainButton = (client) => {
		console.log('styleExtraDocMainButton');
		var combinedSignature = [];
		var sigReqExtraObj =
			client?.documentInformation?.signatureRequestsExtras;

		var sigReqExtraKeys = sigReqExtraObj && Object.keys(sigReqExtraObj);

		if (sigReqExtraKeys) {
			console.log('Length of sigReqExtraKeys', sigReqExtraKeys.length);

			for (var i = 0; i <= sigReqExtraKeys.length; i++) {
				console.log(
					'sigReqExtraObj[sigReqExtraKeys[i]]',
					sigReqExtraObj[sigReqExtraKeys[i]]
				);

				var sigUpdatesObj =
					sigReqExtraObj[sigReqExtraKeys[i]]?.signatureUpdates;

				var sigUpdatesKeys =
					sigUpdatesObj && Object.keys(sigUpdatesObj);

				console.log('sigUpdatesObj', sigUpdatesObj);
				console.log('sigUpdatesKeys', sigUpdatesKeys);

				if (sigUpdatesObj) {
					var signaturesObj =
						sigUpdatesObj[sigUpdatesKeys[sigUpdatesKeys.length - 1]]
							.signature_request.signatures;

					console.log('signaturesObj', signaturesObj);

					combinedSignature.push(signaturesObj);
				}
			}

			console.log('combinedSignature', combinedSignature);

			for (var i = 0; i <= combinedSignature.length; i++) {
				console.log(
					'forEach combinedSignature:' +
						JSON.stringify(combinedSignature[i]?.length)
				);

				for (var x = 0; x <= combinedSignature[i]?.length; x++) {
					console.log(
						'combinedSignature[i][x].status_code',
						combinedSignature[i][x]?.status_code
					);

					if (
						combinedSignature[i][x]?.status_code ===
						'awaiting_signature'
					) {
						return { backgroundColor: '#FFD84E' };
					}
				}
			}
		}
	};

	const styleMainButtonExtra = (client, subjectName) => {
		var signatureObj;
		var subjectNameNode;
		var signatureRequestsExtras =
			client?.documentInformation?.signatureRequestsExtras;

		var signatureRequestsExtrasKeys =
			signatureRequestsExtras && Object.keys(signatureRequestsExtras);

		var endColor;

		console.log('styleMainButtonExtra client', client);

		for (var i = 0; i <= signatureRequestsExtrasKeys?.length; i++) {
			if (
				signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
					?.signatureUpdates
			) {
				console.log('i index', i);
				var signatureUpdates =
					signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
						?.signatureUpdates;

				var signatureUpdatesKeys =
					signatureUpdates && Object.keys(signatureUpdates);

				subjectNameNode =
					signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
						?.subject;

				console.log('Line 1899: ', subjectNameNode);

				signatureObj =
					signatureUpdates &&
					signatureUpdates[
						signatureUpdatesKeys[signatureUpdatesKeys?.length - 1]
					]?.signature_request.signatures;

				var eventType =
					signatureUpdates &&
					signatureUpdates[
						signatureUpdatesKeys[signatureUpdatesKeys?.length - 1]
					]?.event.event_type;

				if (
					subjectNameNode === subjectName &&
					eventType !== 'signature_request_canceled' &&
					signatureObj
				) {
					if (signatureObj[2]?.signer_role === 'Second Purchaser') {
						if (
							signatureObj[0].status_code === 'signed' && //Purchaser
							signatureObj[1].status_code === 'signed' && //Witness
							signatureObj[2].status_code === 'signed' && //Second Purchaser
							signatureObj[3].status_code === 'signed' && //Second Witness
							signatureObj[4].status_code === 'signed' && //Admin
							signatureObj[5].status_code === 'signed' //Builder
						) {
							endColor = {
								backgroundColor: '#52DC19',
								color: '#FFFFFF',
							};
						} else if (
							signatureObj[0].status_code === 'signed' && //Purchaser
							signatureObj[1].status_code === 'signed' && //Witness
							signatureObj[2].status_code === 'signed' && //Second Purchaser
							signatureObj[3].status_code === 'signed' && //Second Witness
							signatureObj[4].status_code === 'signed' // admin
						) {
							endColor = { backgroundColor: '#FFD84E' }; //yellow
						} else if (
							signatureObj[0].status_code === 'signed' && //Purchaser
							signatureObj[1].status_code === 'signed' && //Witness
							signatureObj[2].status_code === 'signed' && //Second Purchaser
							signatureObj[3].status_code === 'signed' //Second Witness
						) {
							endColor = { backgroundColor: '#FF8A27' };
						} else {
							endColor = { backgroundColor: '#FFD84E' };
						}
					} else if (signatureObj?.length === 4) {
						if (
							signatureObj[0]?.status_code === 'signed' &&
							signatureObj[1]?.status_code === 'signed' &&
							signatureObj[2]?.status_code === 'signed' &&
							signatureObj[3]?.status_code === 'signed'
						) {
							endColor = {
								backgroundColor: '#52DC19',
								color: '#FFFFFF',
							};
						} else if (
							signatureObj[0].status_code === 'signed' &&
							signatureObj[1].status_code === 'signed' &&
							signatureObj[2].status_code === 'signed' &&
							signatureObj[3].status_code === 'awaiting_signature'
						) {
							endColor = { backgroundColor: '#FFD84E' };
						} else if (
							signatureObj[0].status_code === 'signed' &&
							signatureObj[1].status_code === 'signed' &&
							signatureObj[2].status_code ===
								'awaiting_signature' &&
							signatureObj[3].status_code === 'awaiting_signature'
						) {
							endColor = { backgroundColor: '#FF8A27' };
						} else if (
							signatureObj[0].status_code === 'signed' &&
							signatureObj[1].status_code ===
								'awaiting_signature' &&
							signatureObj[2].status_code ===
								'awaiting_signature' &&
							signatureObj[3].status_code === 'awaiting_signature'
						) {
							endColor = { backgroundColor: '#FFD84E' };
						} else if (
							signatureObj[0].status_code ===
								'awaiting_signature' &&
							signatureObj[1].status_code ===
								'awaiting_signature' &&
							signatureObj[2].status_code ===
								'awaiting_signature' &&
							signatureObj[3].status_code === 'awaiting_signature'
						) {
							endColor = { backgroundColor: '#FFD84E' };
						}
					} else if (signatureObj.length === 5) {
						if (
							signatureObj[signatureObj.length - 1]
								.status_code === 'signed'
						) {
							endColor = {
								backgroundColor: '#52DC19',
								color: '#FFFFFF',
							};
						} else if (
							signatureObj[signatureObj.length - 2]
								.status_code === 'signed'
						) {
							endColor = { backgroundColor: '#FFD84E' };
						} else if (
							signatureObj[signatureObj.length - 3]
								.status_code === 'signed'
						) {
							endColor = { backgroundColor: '#FF8A27' };
						} else {
							endColor = { backgroundColor: '#FFD84E' };
						}
					} else if (signatureObj[2]?.signer_role) {
						if (
							signatureObj[0]?.status_code === 'signed' &&
							signatureObj[1]?.status_code === 'signed' &&
							signatureObj[2]?.status_code === 'signed'
						) {
							console.log(subjectName + 'Im here 3');
							endColor = {
								backgroundColor: '#52DC19',
								color: '#FFFFFF',
							};
						} else if (
							signatureObj[0].status_code === 'signed' &&
							signatureObj[1].status_code === 'signed' &&
							signatureObj[2].status_code === 'awaiting_signature'
						) {
							endColor = { backgroundColor: '#FFD84E' };
						} else if (
							signatureObj[0].status_code === 'signed' &&
							signatureObj[1].status_code ===
								'awaiting_signature' &&
							signatureObj[2].status_code === 'awaiting_signature'
						) {
							endColor = { backgroundColor: '#FF8A27' };
						} else if (
							signatureObj[0].status_code ===
								'awaiting_signature' &&
							signatureObj[1].status_code ===
								'awaiting_signature' &&
							signatureObj[2].status_code === 'awaiting_signature'
						) {
							endColor = { backgroundColor: '#FFD84E' };
						}
					} else if (signatureObj?.length === 2) {
						if (signatureObj[1].status_code === 'signed') {
							endColor = {
								backgroundColor: '#52DC19',
								color: '#FFFFFF',
							};
						} else {
							endColor = { backgroundColor: '#FFD84E' };
						}
					} else {
						if (
							signatureObj[signatureObj.length - 1]
								.status_code === 'signed'
						) {
							endColor = {
								backgroundColor: '#52DC19',
								color: '#FFFFFF',
							};
						} else {
							endColor = { backgroundColor: '#FFD84E' };
						}
					}
				}
			} else if (
				signatureRequestsExtras &&
				subjectName ===
					signatureRequestsExtras[signatureRequestsExtrasKeys[i]]
						?.subject
			) {
				endColor = { backgroundColor: '#FFD84E' }; // yellow
			}
		}

		return endColor;
	};

	const jsxForInsideExtraDocuments = (expandedClient, client) => {
		var currentUserEmail = firebase.auth().currentUser.email;
		console.log(
			'jsxForInsideExtraDocuments all_documents',
			ALL_DOCUMENTS.allDocumentTypeInfo
		);

		return (
			<>
				{ALL_DOCUMENTS.allDocumentTypeInfo.extraDocumentInfo.map(
					(extraDoc) => {
						console.log('extraDoc: ', extraDoc);
						return (
							<div className='extra-docs-btn-list'>
								<div className='d-flex button_status_group'>
									<button
										className='btn btn-client-actions-extra'
										style={{
											...styleMainButtonExtra(
												client,
												extraDoc.subjectName
											),
										}}
										onClick={(e) => {
											//closeDocModalHandler();
											if (
												checkIfApsSent(client) === true
											) {
												setExtraDocPopulation({
													client: client,
													extraDoc: extraDoc,
												});
												// setShowExtraDoc(true);
												setShowAddDoc({
													visible: false,
													client: client,
												});
												handleClickForm(
													e,
													client,
													extraDoc,
													extraDoc.subjectName
												);
											} else {
												setAlert(
													'Must send ' +
														client.clientEmail +
														' an APS before sending extra documents'
												);
												setSnackbar(true);
												setSnackbarType('warning');
												setTimeout(() => {
													setAlert();
												}, 4000);
												closeDocModalHandler();
											}
										}}
									>
										{extraDoc.name}
									</button>
									<div className='status_wrapper'>
										<div className='status_ticker_wrap'>
											<FiberManualRecordOutlinedIcon
												className='status_signed'
												style={{
													...styleClientStatusColorExtra(
														expandedClient,
														client,
														extraDoc.subjectName
													),
												}}
											/>
											<span>Client</span>
										</div>
										<div className='status_ticker_wrap'>
											<FiberManualRecordOutlinedIcon
												className='status_signed'
												style={{
													...styleBuilderStatusColorExtra(
														expandedClient,
														client,
														extraDoc.subjectName
													),
												}}
											/>
											<span>Builder</span>
										</div>
									</div>
								</div>
								<br></br>
							</div>
						);
					}
				)}
			</>
		);
	};

	const checkIfApsSent = (client) => {
		if (
			client.documentInformation !== undefined &&
			client.documentInformation !== null
		) {
			if (
				client.documentInformation.documentStatus !== undefined &&
				client.documentInformation.documentStatus !== null
			) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	};

	const handleExtraFiles = async (client, subject) => {
		console.log('handleExtraFiles You clicked on ', subject);

		var dataJson = {
			appcode: client.appCode,
			keyvalue: client.keyValue,
			salesagentpointer: client.salesAgentPointer,
			name: client.fullName,
			clientemail: client.clientEmail,
		};

		var currentUserId = firebase.auth().currentUser.uid;

		setDocLoading(true);
		await GetClientExtraFilesBySubject(
			dataJson,
			currentUserId,
			subject,
			ORIGINAL_HREF.originalHREF['access_token']
		).then((returned) => {
			if (returned.data.status === 'complete') {
				console.log(JSON.stringify(returned.data.signatureRequestId));
				console.log('handleExtraFiles pdf path', returned.data.pdfPath);

				firebase
					.database()
					.ref(returned.data.pdfPath)
					.child('base64pdf')
					.once('value', (snapshot) => {
						//then we view the pdf in here
						if (
							snapshot.val() !== undefined &&
							snapshot.val() !== null &&
							snapshot.val()
						) {
							var isReady = snapshot.val();
							console.log(
								' handleExtraFiles is ready ?' + isReady
							);

							if (isReady) {
								console.log(' handleExtraFiles countt ?');
								window.open(
									isReady,
									'View Extra File',
									'toolbar=no,resizable=yes,location=yes,menubar=yes'
								);
								setDocLoading(false);
								return false;
							}
						}
					});
			} else if (returned.data.status === 'no_document') {
				setAlert('Document has not been sent yet.');
				setSnackbar(true);
				setSnackbarType('warning');
				setTimeout(() => {
					setAlert();
				}, 4000);
				setDocLoading(false);
				//still_processing
			} else if (returned.data.status === 'still_processing') {
				setAlert('Document is still processing try again later.');
				setSnackbar(true);
				setSnackbarType('warning');
				setTimeout(() => {
					setAlert();
				}, 4000);
				setDocLoading(false);
				//still_processing
			}
		});
		// data-appcode={client.appCode}
		// data-keyvalue={client.keyValue}
		// data-salesagentpointer={client.salesAgentPointer}
		// data-name={client.fullName}
		// data-clientemail={client.clientEmail}
	};

	return (
		<>
			{loading && (
				<div className='loading_layout_clients'>
					<CircularProgress
						style={{ position: 'fixed', left: '50%', top: '50%' }}
					/>
				</div>
			)}

			{docLoading && (
				<div className='loading_layout_clients'>
					<CircularProgress
						style={{ position: 'fixed', left: '50%', top: '50%' }}
					/>
				</div>
			)}

			<div className='clients-page'>
				{alert && (
					<CustomAlerts
						alertType={snackbarType}
						alertMsg={alert}
						setSnackbar={setSnackbar}
						snackbar={snackbar}
					/>
				)}
				<div className='client_header'>
					<h2 id='client-title'>Clients</h2>
					<div className='client_header_right'>
						<div
							className='add-client-btn'
							onClick={() => setShow(true)}
						>
							<AddCircleIcon />
							<p>Add Client</p>
						</div>
					</div>
				</div>
				<div className='legend_group'>
					<div className='legend_label_group'>
						<div className='legend_status'>
							<FiberManualRecordOutlinedIcon
								style={{
									stroke: '#34D1BF',
									strokeWidth: '2.3px',
									height: '16px',
								}}
								className='status_signed'
							/>
						</div>
						<div className='legend_label'>Signed</div>
					</div>
					<div className='legend_label_group'>
						<div className='legend_status'>
							<FiberManualRecordOutlinedIcon
								style={{
									stroke: '#f17105',
									strokeWidth: '2.3px',
									height: '16px',
								}}
								className='status_signed'
							/>
						</div>
						<div className='legend_label'>Not Signed</div>
					</div>
					<div className='legend_label_group'>
						<div
							className='legend_status'
							style={{
								marginTop: '5px',
								color: '#F1F5F8',
								stroke: 'black',
							}}
						>
							<StopIcon className='status_signed' />
						</div>
						<div className='legend_label'>Signature not sent</div>
					</div>
					<div className='legend_label_group'>
						<div
							className='legend_status'
							style={{ marginTop: '5px', color: '#FFD84E' }}
						>
							<StopIcon className='status_signed' />
						</div>
						<div className='legend_label'>Signature pending</div>
					</div>
					<div className='legend_label_group'>
						<div
							className='legend_status'
							style={{ marginTop: '5px', color: '#FF8A27' }}
						>
							<StopIcon className='status_signed' />
						</div>
						<div className='legend_label'>Admin review</div>
					</div>
					<div className='legend_label_group'>
						<div
							className='legend_status'
							style={{ marginTop: '5px', color: '#52DC19' }}
						>
							<StopIcon className='status_signed' />
						</div>
						<div className='legend_label'>Document completed</div>
					</div>
				</div>
				<SearchBox
					placeholder={`Search Clients (By full name, email, lot number) ${
						userType === 'superadmin' || userType === 'salesadmin'
							? ', Search specific Sales Agents clients (@Sales Agents)'
							: ''
					}`}
					handleChange={handleChange}
				/>

				<Paper className='client-details-table'>
					<Table className={styles.table}>
						<TableHead>
							<TableRow>
								<TableCell className={styles.tableCell}>
									Lot Number
								</TableCell>
								<TableCell className={styles.tableCell}>
									Full name
								</TableCell>
								<TableCell className={styles.tableCell}>
									Date
								</TableCell>
								<TableCell className={styles.tableCell}>
									Cooling Period End
								</TableCell>
								<TableCell
									className={clsx(
										styles.tableCell,
										styles.docHeader
									)}
									align='center'
									colSpan='3'
								>
									Documents
								</TableCell>
							</TableRow>
						</TableHead>

						<ClientList
							clientDetailList={clientDetailList}
							jsxForExpandedClient={jsxForExpandedClient}
							handleDocument={handleDocument}
							handleDelete={handleDelete}
							filteredClients={filteredClients}
							stableSort={stableSort}
							getComparator={getComparator}
							page={page}
							rowsPerPage={rowsPerPage}
							order={order}
							orderBy={orderBy}
							setShowDocInfo={setShowDocInfo}
							setClientJson={setClientJson}
							handleDocumentInformation={
								handleDocumentInformation
							}
							userType={userType}
							setExtendModal={setExtendModal}
							setExtendInfo={setExtendInfo}
						/>
					</Table>
				</Paper>
				{sortClientList === undefined ||
					sortClientList === null ||
					(sortClientList === '' && <div>Test</div>)}
				<Modal
					show={show}
					close={closeModalHandler}
					title='Add Client'
					buttonName='Add'
					button={handleAddClient}
				>
					<AddNewClientJsx
						alertModal={alertModal}
						snackbar={snackbar}
						setSnackbar={setSnackbar}
						setViewLeads={setViewLeads}
						setShow={setShow}
						clientEmail={clientEmail}
						clientName={clientName}
						clientPhoneNumber={clientPhoneNumber}
						onChange={onChange}
					/>
				</Modal>
				<Modal
					show={showAuditTrail}
					close={closeAudittrailModalHandler}
					title='Audit trail'
					buttonName='Close'
					button={closeAudittrailModalHandler}
				>
					<h1>Events</h1>
					<Paper className='audit-trail-table'>
						<Table className={styles.table}>
							<TableHead>
								<TableRow>
									<TableCell className={styles.tableCell}>
										Time
									</TableCell>
									<TableCell className={styles.tableCell}>
										User
									</TableCell>
									<TableCell className={styles.tableCell}>
										Action
									</TableCell>
								</TableRow>
							</TableHead>
							{auditTrail?.map((trail) => {
								var strEventType = trail.eventType;

								console.log('strEventType: ' + strEventType);

								var newEventType = strEventType.replaceAll(
									'_',
									' '
								);

								var capFirstEventType =
									newEventType.charAt(0).toUpperCase() +
									newEventType.slice(1);

								console.log(
									'strEventType replace: ' + newEventType
								);
								return (
									<>
										<TableRow>
											<TableCell
												className={styles.eventContent}
											>
												{dayjs(
													trail.eventTime * 1000
												).format('DD MMMM YYYY HH:mm')}
											</TableCell>
											<TableCell
												className={styles.eventContent}
											>
												{/* {capFirstEventType} by{' '}
												{firebase.auth().currentUser.displayName} */}
											</TableCell>
											<TableCell
												className={styles.eventContent}
											>
												{capFirstEventType} by{' '}
												{
													firebase.auth().currentUser
														.displayName
												}
											</TableCell>
										</TableRow>
										{trail.signatureDetails?.map(
											(signer) => {
												// signerEmail: signerEmail,
												// signerStatus: signerStatus,
												var strSignerStatus =
													signer.signerStatus;
												var lowercaseSignerStatus =
													strSignerStatus.toLowerCase();
												var capFirstSignerStatus =
													lowercaseSignerStatus
														.charAt(0)
														.toUpperCase() +
													lowercaseSignerStatus.slice(
														1
													);
												var newSignerStatus =
													capFirstSignerStatus.replaceAll(
														'_',
														' '
													);

												console.log(
													'Signger: ' +
														JSON.stringify(signer)
												);
												return (
													<TableRow>
														<TableCell
															className={
																styles.eventContent
															}
														>
															{dayjs(
																trail.eventTime *
																	1000
															).format(
																'DD MMMM YYYY HH:mm'
															)}
														</TableCell>
														<TableCell
															className={
																styles.eventContent
															}
														>
															<strong>
																{
																	signer.signerRole
																}
															</strong>{' '}
															{signer.signerEmail}
														</TableCell>
														<TableCell
															className={
																styles.eventContent
															}
														>
															{newSignerStatus}
															{/* <strong>{signer.signerRole}</strong>{' '}
														{signer.signerEmail} */}
														</TableCell>
													</TableRow>
												);
											}
										)}
									</>
								);
							})}
						</Table>
					</Paper>
				</Modal>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25, 50]}
					component='div'
					count={filteredClients?.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					className='client-pagination'
					labelRowsPerPage={
						<div style={{ color: 'var(--text-high-emphasis)' }}>
							Rows per page
						</div>
					}
					nextIconButtonProps={{
						style: {
							padding: '0px',
						},
					}}
					backIconButtonProps={{
						style: {
							padding: '0px',
							marginLeft: '-10px',
						},
					}}
					SelectProps={{
						style: {
							border: '1px solid var(--text-mid-emphasis)',
							borderRadius: '4px',
							padding: '4px',
							marginRight: '10px',
						},
					}}
				/>

				<Modal
					show={showDocModal.aps}
					close={closeDocControlHandle}
					title='Manage document'
					buttonName='Close'
					button={closeDocControlHandle}
				>
					{manageDocModal(
						showDocModal.currentClient,
						showDocModal.aps,
						showDocModal.condodocs
					)}
				</Modal>

				<Modal
					show={showDocModal.condodocs}
					close={closeDocControlHandle}
					title='Manage document'
					buttonName='Close'
					button={closeDocControlHandle}
				>
					{manageDocModal(
						showDocModal.currentClient,
						showDocModal.aps,
						showDocModal.condodocs
					)}
				</Modal>

				<Modal
					show={showDocModal.extraDocs}
					close={closeDocControlHandle}
					title='Manage document'
					buttonName='Close'
					button={closeDocControlHandle}
				>
					{manageDocModal(
						showDocModal.currentClient,
						showDocModal.aps,
						showDocModal.condodocs,
						showDocModal.extraDocs,
						showDocModal.extraDoc,
						showDocModal.subject
					)}
				</Modal>

				{showAddDoc.visible === true && (
					<Modal
						show={showAddDoc.visible}
						close={closeDocModalHandler}
						title='Add Document'
						buttonName='Add'
						button={handleAddDocument}
					>
						{jsxForInsideExtraDocuments(
							showAddDoc.client['expandedClientInfo'],
							showAddDoc.client
						)}
					</Modal>
				)}

				{docInformation !== undefined && (
					<Modal
						show={showDocInfo}
						close={closeDocInfoModalHandler}
						title='View document information'
						buttonName='Close'
						button={closeDocInfoModalHandler}
					>
						{console.log(
							'docInformation in jsx: ' +
								JSON.stringify(docInformation)
						)}
						<div className='total_progress_final_display'>
							{docInformation?.lotObj && (
								<div className='lot_modelhomes_container'>
									<div className='lot_single_card'>
										<p className='lot_single_title'>
											{docInformation?.lotObj?.lotName}{' '}
											{
												docInformation?.lotObj
													?.elevationId
											}
										</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon className='available' />
											</span>

											{`Lot ${docInformation?.lotObj?.lotSelected} / ${docInformation?.lotObj?.lotSqft} SQFT / $${docInformation?.lotObj?.lotPrice}`}
										</small>
										<br />
									</div>
								</div>
							)}
						</div>

						<div className='total_progress_final_display'>
							{docInformation?.individualsObj && (
								<div className='lot_modelhomes_container'>
									<div className='lot_single_card'>
										<p className='lot_single_title'>
											{
												docInformation?.individualsObj
													?.firstName
											}
										</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon className='available' />
											</span>
											{
												docInformation?.individualsObj
													?.address
											}
										</small>
										<br />
										<small className='small_number'>
											{
												docInformation?.individualsObj
													?.phoneNumber
											}
										</small>
									</div>
								</div>
							)}
						</div>
						<div className='total_progress_final_display'>
							<div className='lot_modelhomes_container'>
								{docInformation?.lawyerObj && (
									<div className='lot_single_card'>
										<small className='single_card_label'>
											Lawyer
										</small>
										<p className='lot_single_title'>
											{
												docInformation?.lawyerObj
													?.companyName
											}
										</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon className='available' />
											</span>
											{docInformation?.lawyerObj?.address}
										</small>
										<br />
										<small className='small_number'>
											{
												docInformation?.lawyerObj
													?.phoneNumber
											}
										</small>
									</div>
								)}
							</div>
						</div>
						<div className='total_progress_final_display'>
							<div className='lot_modelhomes_container'>
								{docInformation?.coBrokerObj && (
									<div className='lot_single_card'>
										<small className='single_card_label'>
											Co-Broker
										</small>
										<p className='lot_single_title'>{`${docInformation?.coBrokerObj?.salesAgency} `}</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon className='available' />
											</span>
											{
												docInformation?.coBrokerObj
													?.agentName
											}
										</small>
										<br />
										<small className='small_number'>
											{
												docInformation?.coBrokerObj
													?.phoneNumber
											}
										</small>
									</div>
								)}
							</div>
						</div>
						<div className='lot_modelhomes_container'>
							{docInformation?.mortgageObj && (
								<div className='lot_single_card'>
									<p className='lot_single_title'>
										{
											docInformation?.mortgageObj
												?.institutionName
										}
									</p>
									<small className='lot_single_sqft'>
										<span className='lot_availability'>
											<FiberManualRecordIcon className='available' />
										</span>
										TOTAL DOWNPAYMENT
										<span className='mortgage_amount_total'>
											$
											{
												docInformation?.mortgageObj
													?.totalDownpayment
											}
										</span>
									</small>
									<br />
								</div>
							)}
						</div>

						{!docInformation?.lawyerObj && (
							<div className='lot_modelhomes_container'>
								<div
									data-expand={5}
									data-subject='lawyer'
									onClick={(e) => handleAddItemDoc(e)}
									data-appcode={clientJson?.appCode}
									data-name={clientJson?.fullName}
									data-clientemail={clientJson?.clientEmail}
									className='lot_single_card'
								>
									<div className='add_title'>
										<AddCircleOutlineIcon />
										<span>Add Lawyer</span>
									</div>
								</div>
							</div>
						)}
						{!docInformation?.coBrokerObj && (
							<div className='lot_modelhomes_container'>
								<div
									data-expand={6}
									data-subject='cobroker'
									onClick={(e) => handleAddItemDoc(e)}
									data-appcode={clientJson?.appCode}
									data-name={clientJson?.fullName}
									data-clientemail={clientJson?.clientEmail}
									className='lot_single_card'
								>
									<div className='add_title'>
										<AddCircleOutlineIcon />
										<span>Add Co-Broker</span>
									</div>
								</div>
							</div>
						)}
						{!docInformation?.mortgageObj && (
							<div className='lot_modelhomes_container'>
								<div
									data-expand={7}
									data-subject='mortgage'
									onClick={(e) => handleAddItemDoc(e)}
									data-appcode={clientJson?.appCode}
									data-name={clientJson?.fullName}
									data-clientemail={clientJson?.clientEmail}
									className='lot_single_card'
								>
									<div className='add_title'>
										<AddCircleOutlineIcon />
										<span>Add mortgage</span>
									</div>
								</div>
							</div>
						)}
					</Modal>
				)}

				{extraDocFormPopulation.client !== undefined && (
					<Modal
						show={showExtraDocForm}
						close={closeExtraDocForm}
						title={extraDocFormPopulation.extraDoc.name}
						// buttonName={'Create Document'}
					>
						{console.log(
							'about to create document form ',
							extraDocFormPopulation.extraDoc.overideRoles
						)}
						{CreateDocumentForm(
							extraDocFormPopulation.client,
							extraDocFormPopulation.extraDoc,
							extraDocFormPopulation.client.expandedClientInfo,
							firebase,
							setShowExtraDoc,
							customFields,
							setCustomFields,
							select,
							setSelect,
							otherCustomFields,
							setOtherCustomFields,
							{},
							setCustomSigners
						)}
					</Modal>
				)}

				<Modal
					show={addItemDocModal.lawyer}
					title='Add Lawyer'
					close={handleCloseEditItemModal}
				>
					{console.log('This is the modal clientJson', clientJson)}
					<LawyerForm
						setShowDocInfo={setShowDocInfo}
						addItemDocModal={addItemDocModal}
						setAddItemDocModal={setAddItemDocModal}
						clientJson={clientJson}
						setDocInformation={setDocInformation}
						docInformation={docInformation}
						setLoading={setLoading}
					/>
				</Modal>
				<Modal
					show={addItemDocModal.coBroker}
					title='Add Co-Broker'
					close={handleCloseEditItemModal}
				>
					<CoBroker
						setShowDocInfo={setShowDocInfo}
						addItemDocModal={addItemDocModal}
						setAddItemDocModal={setAddItemDocModal}
						clientJson={clientJson}
						setLoading={setLoading}
					/>
				</Modal>
				<Modal
					show={addItemDocModal.mortgage}
					title='Add Mortgage'
					close={handleCloseEditItemModal}
				>
					<MortgageForm
						setShowDocInfo={setShowDocInfo}
						addItemDocModal={addItemDocModal}
						setAddItemDocModal={setAddItemDocModal}
						clientJson={clientJson}
						setLoading={setLoading}
					/>
				</Modal>

				<Modal
					show={showPdfDocument}
					close={handleClosePdfModal}
					title='View PDF'
					buttonName='Close'
					button={handleClosePdfModal}
				>
					<div className='pdfDiv'>
						{console.log('SHOWING DOCUMENT PDF ' + pdfFile)}
						<Document
							file={pdfFile}
							onLoadSuccess={onDocumentLoadSuccess}
						>
							<Page pageNumber={pageNumber} />
						</Document>
						<div className='pdf-control'>
							{pageNumber > 0 && (
								<Button
									onClick={() => {
										setPageNumber(pageNumber - 1);
									}}
									variant='contained'
								>
									Back Page
								</Button>
							)}
							<p>
								Page {pageNumber} of {numPages}
							</p>
							<Button
								onClick={() => {
									setPageNumber(pageNumber + 1);
								}}
								variant='contained'
							>
								Next Page
							</Button>
							{/* <Button
							onClick={() => {
								turnOnPdfDocument(false);
							}}
						>
							Close
						</Button> */}
						</div>
					</div>
				</Modal>
				<Modal
					show={viewLeads}
					close={handleCloseLeads}
					title='View Leads'
					buttonName='Close'
					button={handleCloseLeads}
				>
					<ViewLeads
						viewLeads={viewLeads}
						handleCloseLeads={handleCloseLeads}
						setAlert={setAlert}
						snackbar={snackbar}
						setSnackbar={setSnackbar}
						setSnackbarType={setSnackbarType}
					/>
				</Modal>
				<Modal
					show={extendModal}
					close={closeExtendModalHandler}
					title='Extend cooling period'
				>
					<ExtendCoolingPeriod
						extendInfo={extendInfo}
						closeModalHandler={closeExtendModalHandler}
					/>
				</Modal>
				<Dialog open={deleteClientDialog} onClose={handleCloesDialog}>
					<DialogTitle>Confirm to delete the client?</DialogTitle>
					<DialogActions>
						<Button onClick={handleCloesDialog} color='primary'>
							Cancel
						</Button>
						<Button
							onClick={handleClickClientDelete}
							color='primary'
						>
							Delete
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	visibleClients: state.clients.allVisibleClients,
	coBrokersSalesAgent: state.clients.coBrokersSalesAgent,
	loading: state.clients.loading,
});

export default connect(mapStateToProps, {
	getVisibleClients,
	handleDoc,
})(Clients);
